import { Injectable } from "@angular/core";

@Injectable()
export class LocalStorageService {
  constructor() {}

  /*
     Combine the Area & Type values to create a key that's specific to every instance
     */
  getKey(area: string, type: string): string {
    return area + "." + type;
  }

  /*
     Retrieve a stored value at this key
     */
  get(area: string, type: string): string | null {
    try {
      return localStorage.getItem(this.getKey(area, type));
    } catch (e) {
      return null;
    }
  }

  /*
     Store an item
     */
  store(area: string, type: string, value: string) {
    localStorage.setItem(this.getKey(area, type), value);
  }

  /*
     Delete an item in storage
     */
  remove(area: string, type: string) {
    localStorage.removeItem(this.getKey(area, type));
  }
}
